import { useNavigate } from "react-router-dom";
import { useState } from "react";
import "./Checkout.css";

const Checkout = ({
  cartItems,
  user,
  onOpenLogin,
  onOrderComplete,
}) => {
  const navigate = useNavigate();
  const [step, setStep] = useState("shipping");
  const [shippingData, setShippingData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    postalCode: "",
    country: "Italia",
  });

  const [paymentData, setPaymentData] = useState({
    cardName: "",
    cardNumber: "",
    expiryDate: "",
    cvv: "",
  });

  if (!user) {
    return (
      <div className="checkout-error">
        <h2>Accesso Richiesto</h2>
        <p>Devi effettuare l'accesso per completare l'ordine</p>
        <button onClick={onOpenLogin} className="login-btn">
          Accedi Ora
        </button>
      </div>
    );
  }

  const totalPrice = cartItems.reduce(
    (sum, item) => sum + item.price * item.quantity, //sarebbe tipo una lamba di python
    0
  );
  const shippingCost = totalPrice >= 100 ? 0 : 15;
  const totalWithShipping = totalPrice + shippingCost;

  const handleShippingChange = (e) => {
    const { name, value } = e.target;
    setShippingData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handlePaymentChange = (e) => {
    const { name, value } = e.target;
    let formattedValue = value;

    if (name === "cardNumber") {
      formattedValue = value.replace(/\s/g, "").replace(/(.{4})/g, "$1 ");
    } else if (name === "expiryDate") {
      formattedValue = value.replace(/(\d{2})(\d{2})/, "$1/$2");
    } else if (name === "cvv") {
      formattedValue = value.replace(/\D/g, "").slice(0, 3);
    }

    setPaymentData((prev) => ({
      ...prev,
      [name]: formattedValue,
    }));
  };

  const validateShipping = () => {
    if (
      !shippingData.firstName ||
      !shippingData.lastName ||
      !shippingData.email ||
      !shippingData.address ||
      !shippingData.city ||
      !shippingData.postalCode
    ) {
      alert("Compila tutti i campi dell'indirizzo");
      return false;
    }
    return true;
  };

  const validatePayment = () => {
    if (
      !paymentData.cardName ||
      !paymentData.cardNumber ||
      !paymentData.expiryDate ||
      !paymentData.cvv
    ) {
      alert("Compila tutti i dati della carta");
      return false;
    }
    return true;
  };

  const handlePlaceOrder = () => {
    if (!validatePayment()) return;

    const order = {
      orderId: Math.random().toString(36).substr(2, 9).toUpperCase(),
      date: new Date().toLocaleString("it-IT"),
      user: user,
      items: cartItems,
      shipping: shippingData,
      subtotal: totalPrice,
      shippingCost: shippingCost,
      total: totalWithShipping,
    };

    onOrderComplete(order);
    navigate("/order-confirm");
  };

  return (
  <div className="checkout-page">
    <div className="checkout-container">
      <h1>Checkout</h1>

      {/* STEP BAR SOPRA TUTTO */}
      <div className="checkout-steps">
        <div
          className={`step ${
            step === "shipping" ? "active" : step !== "shipping" ? "completed" : ""
          }`}
        >
          <span className="step-number">1</span>
          <span className="step-name">Indirizzo</span>
        </div>
        <div
          className={`step ${step === "payment" ? "active" : ""}`}
        >
          <span className="step-number">2</span>
          <span className="step-name">Pagamento</span>
        </div>
        <div className="step">
          <span className="step-number">3</span>
          <span className="step-name">Conferma</span>
        </div>
      </div>

      <div className="checkout-content">
        {/* FORM */}
        <div className="checkout-form-section">
          {step === "shipping" && (
            <div className="form-section">
              <h2>Indirizzo di Spedizione</h2>
              <div className="form-row">
                <div className="form-group">
                  <label>Nome *</label>
                  <input
                    type="text"
                    name="firstName"
                    value={shippingData.firstName}
                    onChange={handleShippingChange}
                    placeholder="Mario"
                  />
                </div>
                <div className="form-group">
                  <label>Cognome *</label>
                  <input
                    type="text"
                    name="lastName"
                    value={shippingData.lastName}
                    onChange={handleShippingChange}
                    placeholder="Rossi"
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Email *</label>
                  <input
                    type="email"
                    name="email"
                    value={shippingData.email}
                    onChange={handleShippingChange}
                    placeholder="mario@example.com"
                  />
                </div>
                <div className="form-group">
                  <label>Telefono *</label>
                  <input
                    type="tel"
                    name="phone"
                    value={shippingData.phone}
                    onChange={handleShippingChange}
                    placeholder="+39 123 456 7890"
                  />
                </div>
              </div>

              <div className="form-group full-width">
                <label>Indirizzo *</label>
                <input
                  type="text"
                  name="address"
                  value={shippingData.address}
                  onChange={handleShippingChange}
                  placeholder="Via Roma 123"
                />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Città *</label>
                  <input
                    type="text"
                    name="city"
                    value={shippingData.city}
                    onChange={handleShippingChange}
                    placeholder="Milano"
                  />
                </div>
                <div className="form-group">
                  <label>CAP *</label>
                  <input
                    type="text"
                    name="postalCode"
                    value={shippingData.postalCode}
                    onChange={handleShippingChange}
                    placeholder="20100"
                  />
                </div>
              </div>

              <div className="form-group full-width">
                <label>Paese</label>
                <select
                  name="country"
                  value={shippingData.country}
                  onChange={handleShippingChange}
                >
                  <option value="Italia">Italia</option>
                  <option value="Francia">Francia</option>
                  <option value="Germania">Germania</option>
                  <option value="Spagna">Spagna</option>
                </select>
              </div>

              <button
                onClick={() => {
                  if (validateShipping()) setStep("payment");
                }}
                className="next-btn"
              >
                Continua al Pagamento →
              </button>
            </div>
          )}

          {step === "payment" && (
            <div className="form-section">
              <h2>Informazioni di Pagamento</h2>

              <div className="form-group full-width">
                <label>Titolare Carta *</label>
                <input
                  type="text"
                  name="cardName"
                  value={paymentData.cardName}
                  onChange={handlePaymentChange}
                  placeholder="Mario Rossi"
                />
              </div>

              <div className="form-group full-width">
                <label>Numero Carta *</label>
                <input
                  type="text"
                  name="cardNumber"
                  value={paymentData.cardNumber}
                  onChange={handlePaymentChange}
                  placeholder="1234 5678 9012 3456"
                  maxLength="19"
                />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Scadenza *</label>
                  <input
                    type="text"
                    name="expiryDate"
                    value={paymentData.expiryDate}
                    onChange={handlePaymentChange}
                    placeholder="MM/YY"
                    maxLength="5"
                  />
                </div>
                <div className="form-group">
                  <label>CVV *</label>
                  <input
                    type="text"
                    name="cvv"
                    value={paymentData.cvv}
                    onChange={handlePaymentChange}
                    placeholder="123"
                    maxLength="3"
                  />
                </div>
              </div>

              <div className="form-buttons">
                <button
                  onClick={() => setStep("shipping")}
                  className="back-btn"
                >
                  ← Indietro
                </button>
                <button
                  onClick={handlePlaceOrder}
                  className="place-order-btn"
                >
                  Completa Ordine
                </button>
              </div>
            </div>
          )}
        </div>

        {/* RIEPILOGO ORDINE */}
        <aside className="checkout-summary">
          <h3>Riepilogo Ordine</h3>

          <div className="summary-items">
            {cartItems.map((item) => (
              <div key={item.id} className="summary-item">
                <div className="item-details">
                  <span className="item-emoji"><img src={item.image} width={"30%"} /></span>
                  <div>
                    <p>{item.name}</p>
                    <small>Qty: {item.quantity}</small>
                  </div>
                </div>
                <span className="item-total">
                  €{(item.price * item.quantity).toFixed(2)}
                </span>
              </div>
            ))}
          </div>

          <div className="summary-divider"></div>

          <div className="summary-totals">
            <div className="total-row">
              <span>Subtotale:</span>
              <span>€{totalPrice.toFixed(2)}</span>
            </div>
            <div className="total-row">
              <span>Spedizione:</span>
              <span>{shippingCost === 0 ? "GRATIS" : `€${shippingCost}`}</span>
            </div>
            <div className="total-row total">
              <span>Totale:</span>
              <span>€{totalWithShipping.toFixed(2)}</span>
            </div>
          </div>

          <div className="shipping-info">
            <p className="info-label">📦 Spedizione</p>
            <p className="info-text">24-48 ore in Italia</p>
          </div>

          <div className="security-badges">
            <p>🔒 Pagamenti Sicuri</p>
            <p>✓ SSL Protetto</p>
          </div>
        </aside>
      </div>
    </div>
  </div>
);
};

export default Checkout;
